import {memo, useCallback} from 'react'
import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../../components/TextInputV2'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {filterSelector, setFilterRoute} from '../../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../../components/Table/Table'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterRoute: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleChange = useCallback(
    (value: Partial<typeof filter>) => {
      dispatch(setFilterRoute({...filter, ...value}))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filter]
  )

  return (
    <TRowFilter>
      <td></td>
      <td>
        <TextInputV2
          placeholder={t('Sales Org')}
          value={filter.sales_org_code ?? ''}
          onChange={({target}) => handleChange({sales_org_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Route Code')}
          value={filter.route ?? ''}
          onChange={({target}) => handleChange({route: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Route')}
          value={filter.route_desc ?? ''}
          onChange={({target}) => handleChange({route_desc: target.value})}
        />
      </td>
    </TRowFilter>
  )
})
